<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">{{ dynamicTitle }}</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>工作量统计</span>|
					<template v-if="filter.depId">
						<span v-if="dataType == 1">{{ tagName }}出院随访统计|</span>
						<template v-if="dataType == 2">
							<span>
								{{ { 1: '门诊', 2: '出院' }[datasources] }}复诊统计|
							</span>
						</template>
						<span v-text="depName"></span>
					</template>
					<template v-else>
						<span>
							{{
								{1:'门诊',2:'出院'}[datasources]+{1:'随访',2:'复诊'}[dataType]
							}}工作量统计
							
						</span>
					</template>
				</div>
				<a class="back noline" v-if="filter.depId" @click="goBack">返回</a>
			</div>
		</div>
		<div class="collapse-wrap">
			<div class="search-bar">

				<el-form ref="form" label-width="120px">
					<!-- 随访模式：单行显示 -->
					<div v-if="dataType === 1" class="def-key">
						<template v-for="field in currentConfig.searchFields">
							<label v-if="field.type === 'daterange'" :key="field.key + '_label'">
								{{ getFieldLabel(field) }}
								<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']"
									style="width:220px" type="daterange" align="right" unlink-panels range-separator="至"
									start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter[field.key]"
									:picker-options="pickerOptions" @change="handleDynamicFilter(field.key, $event)">
								</el-date-picker>
							</label>

							<div v-else-if="field.type === 'select'" :key="field.key + '_select'"
								style="display: inline-block;" class="selectrig">
								{{ field.label }}
								<el-select v-model="userfilter.name" filterable remote clearable reserve-keyword
									placeholder="请输入关键词" :remote-method="remoteMethod"
									@change="handleSelectFilter(field.key, $event)"
									@blur="handleSelectBlur(field.key, $event)" :loading="loading"
									style="height: 32px;">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</template>

						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport">
							<i class="icon-export" style="margin-right: 10px;"></i>导出
						</el-button>
					</div>

					<!-- 复诊模式：分两行显示 -->
					<template v-else-if="dataType === 2">
						<!-- 第一行：前三个字段 -->
						<div class="def-key">
							<template v-for="(field) in currentConfig.searchFields.slice(0, 3)">
								<label v-if="field.type === 'daterange'" :key="field.key + '_label'">
									{{ getFieldLabel(field) }}
									<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']"
										style="width:220px" type="daterange" align="right" unlink-panels
										range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
										v-model="filter[field.key]" :picker-options="pickerOptions"
										@change="handleDynamicFilter(field.key, $event)">
									</el-date-picker>
								</label>

							</template>
						</div>

						<!-- 第二行：后三个字段 + 按钮 -->
						<div class="def-key">
							<template v-for="(field) in currentConfig.searchFields.slice(3)">
								<div v-if="field.type === 'select'" :key="field.key + '_select'"
									style="display: inline-block;" class="selectrig">
									{{ field.label }}
									<el-select size="small" filterable clearable v-model="filter[field.key]"
										placeholder="请选择" @change="handleSelectChange(field.key, $event)">
										<el-option v-for="item in getSelectOptions(field.key)"
											:key="item.value || item.id" :label="item.label || item.name"
											:value="item.value || item.id">
										</el-option>
									</el-select>
								</div>
								<div v-else-if="field.type === 'remote'" :key="field.key + '_remote'"
									style="display: inline-block;" class="selectrig">
									{{ field.label }}
									<el-select v-model="userfilter.name" filterable remote clearable reserve-keyword
										placeholder="请输入关键词" :remote-method="remoteMethod"
										@change="handleSelectFilter(field.key, $event)"
										@blur="handleSelectBlur(field.key, $event)" :loading="loading"
										style="height: 32px;">
										<el-option v-for="item in options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
							</template>

							<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
							<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport">
								<i class="icon-export" style="margin-right: 10px;"></i>导出
							</el-button>
						</div>
					</template>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<template v-for="(column, index) in currentConfig.tableColumns">
						<!-- 普通列（无自定义模板或无医院条件限制） -->
						<el-table-column
							v-if="!column.children && (!column.hasRateicon || (column.hasRateicon && hospitalCode === 'SD_LY1'))"
							:key="index" :prop="column.prop" :label="getColumnLabel(column)" :width="column.width">
						</el-table-column>

						<!-- 带自定义模板且有医院条件的列（非SD_LY1医院显示问号图标） -->
						<el-table-column v-else-if="!column.children && column.hasRateicon && hospitalCode !== 'SD_LY1'"
							:key="index" :prop="column.prop" :width="column.width">
							<template slot="header">
								{{ column.label }}
								<img @click="openModal(column.headerType)" class="t-img"
									src="../../assets/images/question-fill.png" alt="">
							</template>
							<template slot-scope="scope">
								<span>{{ scope.row[column.prop] }}</span>
								<img @click="openModal(column.columnType, scope.row)" class="t-img"
									src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>

						<!-- 分组列 -->
						<el-table-column v-else-if="column.children" :key="index" :label="column.label">
							<el-table-column v-for="child in column.children" :key="child.prop" :prop="child.prop"
								:label="child.label">
							</el-table-column>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber - 1) * filter.pageSize + 1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />

	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import ModalCommon from './components/modalCommon.vue';
import questionFillImg from '@/assets/images/question-fill.png';

export default {
	mixins: [mixin],
	components: { ModalCommon },

	computed: {
		// 当前显示模式
		currentMode() {
			return { 1: 'followup', 2: 'revisit' }[this.dataType]
		},
		// 当前配置
		currentConfig() {
			return this.displayConfigs[this.currentMode];
		},
		// 动态标题
		dynamicTitle() {
			if (this.filter.depId) {
				switch (this.dataType) {
					case 1:
						return '疾病管理师工作量统计'
					case 2:
						return '医生复诊工作量统计'
				}
			}
			const prefix = this.datasources == 1 ? '门诊' : '出院';
			return `${prefix}${this.currentConfig.title}`;
		}
	},
	data() {
		return {
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null,
				summary: []
			},
			filter: {
				followupTimeStart: '',
				followupTimeEnd: '',
				depId: '',
				diseaseManagerId: '',
				pageNumber: 1,
				pageSize: 10,
				outHospitalTimeEnd: '',
				outHospitalTimeStart: '',
				tagId: '',
				datasources: null,
				outdate: []
			},
			depName: '',
			managerList: [],
			permission: false,
			tagName: '',
			userfilter: {
				name: '',
				username: '',
				roleId: undefined,
				departmentId: undefined,
				pageNumber: 1,
				pageSize: 999
			},
			options: [],
			loading: false,
			datasources: 0,//1:门诊2出院
			dataType: 1,//1:随访，2：复诊
			deptList: [], // 科室列表
			orgList: [], // 机构列表
			hospitalCode: '', // 医院代码
			dlg: {
				visible: false,
				type: '',
				propname: '',
				data: {},
			},
			// 显示模式配置
			displayConfigs: {
				followup: {
					title: '随访工作量统计',
					searchFields: [
						{ key: 'followupDate', label: '应随访日期', type: 'daterange' },
						{ key: 'actualDate', label: '实际随访日期', type: 'daterange' },
						{ key: 'outdate', label: '出院日期', type: 'daterange' },
						{ key: 'manager', label: '实际随访人', type: 'select' }
					],
					tableColumns: [
						{ prop: 'depName', label: '科室' },
						{ prop: 'diseaseManager', label: '实际随访人' },
						{ prop: 'followupTotal', label: '应随访人次' },
						{ prop: 'notFollowTimeTotal', label: '未到随访时间人次' },
						{ prop: 'temporaryTotal', label: '暂存人次' },
						{
							label: '有效已随访人次',
							children: [
								{ prop: 'followupFinishedFirstTotal', label: '首次' },
								{ prop: 'followupFinishedSecondTotal', label: '二次' },
								{ prop: 'followupFinishedThreeMoreTotal', label: '三次及以上' },
								{ prop: 'validTotal', label: '合计' }
							]
						},
						{ prop: 'shutdownTotal', label: '终止随访人次' },
						{
							prop: 'shutdownRate',
							label: '终止随访率',
							hasRateicon: true,
							headerType: 'header5',
							columnType: 'column5'
						},
						{
							prop: 'followupCompletionRate',
							label: '随访完成率',
							hasRateicon: true,
							headerType: 'header',
							columnType: 'column'
						},
						{
							prop: 'validRate',
							label: '有效占比',
							hasRateicon: true,
							headerType: 'header1',
							columnType: 'column1'
						},
						{ prop: 'invalidTotal', label: '无效已随访人次' },
						{
							label: '无效随访原因',
							children: [
								{ prop: 'reason1', label: '未接' },
								{ prop: 'reason2', label: '关机' },
								{ prop: 'reason3', label: '电话不通' },
								{ prop: 'reason4', label: '长时间超过10次无人接听' },
								{ prop: 'reason5', label: '停机' },
								{ prop: 'reason6', label: '空号' },
								{ prop: 'reason7', label: '错号' },
								{ prop: 'reason8', label: '拒接' },
								{ prop: 'reason9', label: '修改号' },
								{ prop: 'reason10', label: '其他' }
							]
						}
					]
				},
				revisit: {
					title: '复诊工作量统计',
					searchFields: [
						{ key: 'outdate', label: '出院日期', type: 'daterange' },
						{ key: 'appointmentTime', label: '预约复诊日期', type: 'daterange' },
						{ key: 'returnDate', label: '实际复诊日期', type: 'daterange' },
						{ key: 'depId', label: '科室', type: 'select', options: [] },
						{ key: 'orgId', label: '机构', type: 'select', options: [] },
						{ key: 'doctorId', label: '科室医生', type: 'remote' }
					],
					tableColumns: [
						{ prop: 'depName', label: '科室', width: '280' },
						{ prop: 'doctorName', label: '科室医生' },
						{ prop: 'totalNumbers', label: '出院总人次' },
						{ prop: 'returnVisitTotal', label: '预约复诊人次' },
						{
							prop: 'reservationRate',
							label: '预约率',
							hasRateicon: true,
							headerType: 'header',
							columnType: 'column'
						},
						{ prop: 'toBeTotal', label: '未到复诊时间' },
						{ prop: 'actualTotal', label: '已复诊人次' },
						{ prop: 'nonPerformanceTotal', label: '未履约人次' },
						{
							prop: 'agreementRate',
							label: '履约率',
							hasRateicon: true,
							headerType: 'header1',
							columnType: 'column1'
						}
					]
				}
			}
		}
	},
	watch: {
		// 优化后的路由监听
		'$route.query': {
			handler(newQuery, oldQuery) {
				// 避免初始化时重复调用
				if (!oldQuery) return;

				const keyParams = ['datasources', 'type', 'tagId', 'depId'];
				const dateChange = JSON.stringify(newQuery.date) !== JSON.stringify(oldQuery.date);
				const hasKeyChange = keyParams.some(key => newQuery[key] !== oldQuery[key]) || dateChange;

				if (hasKeyChange) {
					this.initializeFromQuery(newQuery);
					// 处理路由中的日期参数
					if (newQuery.date) {
						this.handleDateParams(newQuery);
					}
					this.loadList();
				}
			},
			immediate: false
		}
	},

	created() {
		console.log(this.$route.query.date, '=========this.$route.query.date')

		// 获取医院代码
		this.getHospitalCode();

		this.initializeFromQuery(this.$route.query);

		// 在初始化之后处理日期参数，避免被 resetFilter 覆盖
		if (this.$route.query.date) {
			this.handleDateParams(this.$route.query);
		}

		this.loadManagerList();
		this.loadList();
	},
	methods: {
		// 获取字段标签（支持动态标签）
		getFieldLabel(field) {
			if (field.key == 'outdate') {
				return `${this.datasources === 1 ? '就诊' : '出院'}日期`;
			}
			return field.label;
		},

		// 获取列标签（支持动态标签）
		getColumnLabel(column) {
			if (column.prop === 'diseaseManager') {
				return this.filter.depId ? '疾病管理师' : '实际随访人';
			}
			if (this.dataType == 2) {
				if (column.prop === 'totalNumbers') {
					return `${this.datasources === 1 ? '就诊' : '出院'}总人次`;
				}
			}
			
			return column.label;
		},
		// 从查询参数初始化数据
		initializeFromQuery(query) {
			// 重置状态
			this.tagName = '';

			// 更新基础参数
			this.datasources = query.datasources;
			this.dataType = Number(query.type) || 1;

			// 重置过滤器
			this.resetFilter(query);

			// 重置用户过滤器
			this.resetUserFilter();

			// 获取 科室下拉
			api.getDeptDropdown({
				departmentType: this.datasources == 1 ? 1 : 0
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			});
			// 获取机构下拉
			api.getListComboboxOrg().then((res) => {
				if (res.code == 1000) {
					this.orgList = res.data;

				} else {
					this.$message.error(res.message)
				}
			})
		},

		handleDateParams(query) {
			let dates = [];

			if (Array.isArray(query.date)) {
				dates = query.date;
			} else if (typeof query.date === 'string') {
				if (query.date.includes(',')) {
					dates = query.date.split(',');
				} else {
					dates = [query.date];
				}
			}

			// 确保有两个日期值
			if (dates.length >= 2) {
				// 设置过滤器的日期字段
				this.filter.outHospitalTimeStart = dayjs(dates[0]).format('YYYY-MM-DD 00:00:00');
				this.filter.outHospitalTimeEnd = dayjs(dates[1]).format('YYYY-MM-DD 23:59:59');

				// 重要：设置UI绑定的日期数组，使用Date对象而不是字符串
				this.filter.outdate = [
					new Date(dates[0]),
					new Date(dates[1])
				];
			}
		},
		// 动态过滤处理
		handleDynamicFilter(fieldKey, value) {
			const fieldMappings = {
				followup: {
					followupDate: { start: 'followupTimeStart', end: 'followupTimeEnd' },
					actualDate: { start: 'followupDateStart', end: 'followupDateEnd' },
					outdate: { start: 'outHospitalTimeStart', end: 'outHospitalTimeEnd' }
				},
				revisit: {
					outdate: { start: 'outHospitalTimeStart', end: 'outHospitalTimeEnd' },
					appointmentTime: { start: 'appointmentTimeStart', end: 'appointmentTimeEnd' },
					returnDate: { start: 'returnVisitDateStart', end: 'returnVisitDateEnd' }
				}
			};

			const mapping = fieldMappings[this.currentMode][fieldKey];
			if (mapping && value) {
				this.filter[mapping.start] = dayjs(value[0]).format('YYYY-MM-DD 00:00:00');
				this.filter[mapping.end] = dayjs(value[1]).format('YYYY-MM-DD 23:59:59');
			} else if (mapping) {
				this.filter[mapping.start] = '';
				this.filter[mapping.end] = '';
			}

			this.filter.pageNumber = 1;
			this.loadList();
		},

		// 选择器变化处理
		handleSelectFilter() {
			this.filter.diseaseManagerId = this.userfilter.name;
			this.filter.pageNumber = 1;
			this.loadList();
		},

		// 选择器失焦处理
		handleSelectBlur() {
			this.filter.diseaseManagerId = this.options[0]?.id;
			this.filter.pageNumber = 1;
			this.loadList();
		},

		remoteMethod(query) {
			if (query !== '') {
				this.userfilter.name = query;
				this.loading = true;
				setTimeout(() => {
					api.getUserList(this.userfilter).then(res => {
						this.loading = false;
						if (res.code == 1000 && res.data) {
							this.options = res.data.map(item => {
								return { value: `${item.id}`, label: `${item.name}`, ...item };
							})
						}
					})
				}, 200);
			} else {
				this.options = [];
			}
		},
		async loadList() {
			this.isLoading = true;
			let res;
			if (this.dataType == 1) {
				if (this.datasources == 1) {
					res = await api.getOutpatientDMList(this.filter);
				} else if (this.datasources == 2 || this.filter.tagId != '') {
					res = await api.getWorkloadDMList(this.filter);
				}
				if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
				this.depName = res.data.list[0]?.depName;
				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', res.data.sum.diseaseManager, res.data.sum.followupTotal, res.data.sum.notFollowTimeTotal, res.data.sum.temporaryTotal, res.data.sum.followupFinishedFirstTotal, res.data.sum.followupFinishedSecondTotal, res.data.sum.followupFinishedThreeMoreTotal, res.data.sum.followupFinishedTotal, res.data.sum.shutdownTotal, res.data.sum.shutdownRate, res.data.sum.followupCompletionRate, res.data.sum.validRate, res.data.sum.invalidTotal, res.data.sum.reason1,
						res.data.sum.reason2, res.data.sum.reason3, res.data.sum
							.reason4, res.data.sum.reason5, res.data.sum.reason6,
						res.data.sum.reason7, res.data.sum.reason8, res.data.sum
							.reason9, res.data.sum.reason10];
					this.list.data = res.data.list;
				}
			} else if (this.dataType == 2) {
				this.filter.datasources = this.datasources;
				res = await api.getReturnReportList(this.filter);
				if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
				this.depName = res.data.list[0]?.depName;
				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', res.data.sum.doctorName, res.data.sum.totalNumbers, res.data.sum.returnVisitTotal, res.data.sum.reservationRate, res.data.sum.toBeTotal, res.data.sum.actualTotal, res.data.sum.nonPerformanceTotal, res.data.sum.agreementRate];
					this.list.data = res.data.list;
				}
			}

			// 权限控制
			this.user = JSON.parse(localStorage.getItem('user')).data;
			this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1" || this.user.user.roleId == "9") ? true : false;
			// 0530 新增
			if (this.filter.tagId != '') {
				let res2 = await api.getTag(this.filter.tagId);
				if (res2.code == 1000 && res2.data) {
					this.tagName = res2.data.name;
				}
			}
			this.isLoading = false;
		},
		getSummaries() {
			// 如果是SD_LY1医院，不添加问号图标
			if (this.hospitalCode === 'SD_LY1') {
				this.$nextTick(() => {
					this.$refs['multipleTable']?.doLayout();
				});
				return this.list.summary;
			}

			// 添加问号图标到合计行
			this.addSummaryIcons();

			this.$nextTick(() => {
				this.$refs['multipleTable']?.doLayout();
			});
			return this.list.summary;
		},

		// 添加合计行问号图标
		addSummaryIcons() {
			const tableRef = this.$refs['multipleTable'];
			if (!tableRef) return;

			const tbodyElement = tableRef.$el.querySelector('tbody.has-gutter');
			if (!tbodyElement) {
				console.error('无法找到<tbody>元素！');
				return;
			}

			// 获取图标配置
			const iconConfig = this.getSummaryIconConfig();

			tbodyElement.querySelectorAll('tr').forEach(tr => {
				const tdElements = tr.querySelectorAll('td');

				iconConfig.forEach(({ index, className, clickHandler }) => {
					const td = tdElements[index];
					if (!td) return;

					const divElement = td.querySelector('.cell');
					const existingImg = document.querySelector(`.${className}`);

					// 如果图标不存在且找到了cell元素，则创建图标
					if (divElement && !existingImg) {
						const imgElement = this.createSummaryIcon(className, clickHandler);
						divElement.appendChild(imgElement);
					}
				});
			});
		},

		// 获取合计行图标配置
		getSummaryIconConfig() {
			const configs = {
				1: [ // 随访模式
					{ index: 10, className: 'img1', clickHandler: () => this.openSumModal('column5') },
					{ index: 11, className: 'img2', clickHandler: () => this.openSumModal('column') },
					{ index: 12, className: 'img3', clickHandler: () => this.openSumModal('column1') }
				],
				2: [ // 复诊模式
					{ index: 4, className: 'img1', clickHandler: () => this.openSumModal('column') },
					{ index: 8, className: 'img2', clickHandler: () => this.openSumModal('column1') }
				]
			};
			return configs[this.dataType] || [];
		},

		// 创建合计行问号图标
		createSummaryIcon(className, clickHandler) {
			const imgElement = document.createElement('img');
			imgElement.src = questionFillImg;
			imgElement.className = className;
			imgElement.addEventListener('click', clickHandler);
			return imgElement;
		},
		// 打开合计行模态框
		openSumModal(type) {
			// 设置基础属性
			this.dlg.type = type;
			this.dlg.propname = this.dataType === 1 ? 'followManage' : 'returnManage';

			// 根据数据类型和类型设置数据
			this.dlg.data = this.getSummaryModalData(type);
			this.dlg.visible = true;
		},

		// 获取合计行模态框数据
		getSummaryModalData(type) {
			const summaryDataConfigs = {
				1: { // 随访模式
					column: {
						followupCompletionRate: this.list.summary[11],
						validTotal: this.list.summary[8],
						invalidTotal: this.list.summary[13],
						notFollowTimeTotal: this.list.summary[3],
						shutdownTotal: this.list.summary[9],
						followupTotal: this.list.summary[2]
					},
					column1: {
						validRate: this.list.summary[12],
						validTotal: this.list.summary[8],
						invalidTotal: this.list.summary[13]
					},
					column5: {
						shutdownRate: this.list.summary[10],
						shutdownTotal: this.list.summary[9],
						followupTotal: this.list.summary[2],
						notFollowTimeTotal: this.list.summary[3]
					}
				},
				2: { // 复诊模式
					column: {
						reservationRate: this.list.summary[4],
						returnVisitTotal: this.list.summary[3],
						totalNumbers: this.list.summary[2]
					},
					column1: {
						agreementRate: this.list.summary[8],
						actualTotal: this.list.summary[6],
						returnVisitTotal: this.list.summary[3],
						toBeTotal: this.list.summary[5]
					}
				}
			};

			return summaryDataConfigs[this.dataType]?.[type] || {};
		},
		// 搜索按钮处理 - 简化版本，主要用于手动触发搜索
		handleFilter() {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		exportReport() {
			this.filter.pageSize = this.list.total;
			let url;
			if (this.dataType == 1) {
				if (this.datasources == 1) {
					url = api.exportStatisticsManage2(this.filter);
				} else if (this.datasources == 2 || this.filter.tagId != '') {
					url = api.exportStatisticsManage(this.filter);
				}
			} else if (this.dataType == 2) {
				url = api.exportListReturnVisitReport(this.filter);
			}
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
			this.filter.pageSize = 10;
		},



		// 重置过滤器
		resetFilter(query) {
			this.filter = {
				followupTimeStart: '',
				followupTimeEnd: '',
				depId: +query.depId || '',
				orgId: '', // 机构ID
				doctorId: '', // 医生ID
				diseaseManagerId: '',
				pageNumber: 1,
				pageSize: 10,
				outHospitalTimeEnd: '',
				outHospitalTimeStart: '',
				tagId: query.tagId || '',
				datasources: query.datasources || null,
				// 复诊相关字段
				appointmentTimeStart: '',
				appointmentTimeEnd: '',
				returnVisitDateStart: '',
				returnVisitDateEnd: '',
				outdate: []
			};
		},

		// 重置用户过滤器
		resetUserFilter() {
			this.userfilter = {
				name: '',
				username: '',
				roleId: undefined,
				departmentId: undefined,
				pageNumber: 1,
				pageSize: 999
			};
		},

		// 加载管理师列表
		async loadManagerList() {
			try {
				const res = await api.getUserList({ roleId: 4 });
				if (res.code === 1000 && res.data) {
					this.managerList = res.data;
				}
			} catch (error) {
				console.error('加载管理师列表失败:', error);
			}
		},

		// 获取选择器选项
		getSelectOptions(fieldKey) {
			switch (fieldKey) {
				case 'depId':
					return this.deptList || [];
				case 'orgId':
					return this.orgList || [];
				case 'doctorId':
					return this.options || [];
				default:
					return [];
			}
		},

		// 处理选择器变化
		handleSelectChange(fieldKey, value) {
			console.log('选择器变化:', fieldKey, value);
			this.filter[fieldKey] = value;
			this.filter.pageNumber = 1;
			this.loadList();
		},

		// 获取医院代码
		getHospitalCode() {
			try {
				const user = JSON.parse(localStorage.getItem('user'));
				this.hospitalCode = user?.data?.hospital?.code || '';
				console.log('医院代码:', this.hospitalCode);
			} catch (error) {
				console.error('获取医院代码失败:', error);
				this.hospitalCode = '';
			}
		},
		openModal(type, data) {
			if (this.dataType == 1) {
				this.dlg.propname = 'followManage'
			} else if (this.dataType == 2) {
				this.dlg.propname = 'returnManage'
			}
			this.dlg.data = data;
			this.dlg.type = type;
			this.dlg.visible = true;
		}

	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
@import './components/sty.less';

.selectrig {
	/deep/ .el-input--suffix {
		input {
			height: 32px !important;
		}

		.el-input__icon {
			line-height: 32px !important;
		}
	}
}

// 问号图标样式
.t-img {
	width: 16px;
	height: 16px;
	margin-left: 5px;
	cursor: pointer;
	vertical-align: middle;
}

// 表头中的问号图标
/deep/ .el-table th .t-img {
	margin-left: 5px;
}

// 表格单元格中的问号图标
/deep/ .el-table td .t-img {
	margin-left: 8px;
}
</style>